export default __webpack_public_path__ + "static/media/06.6786fad0.jpg";